import React, { useEffect, useState, CSSProperties } from 'react';
import Image from 'next/image';
import { useWindowSize } from 'react-use';
import { map } from 'lodash-es';
import './index.less';

interface Breakpoint {
  width: number;
  height: number;
}
interface LogoType {
  path: string;
  name: string;
  breakpoints: {
    bp_300: Breakpoint;
    bp_640: Breakpoint;
    bp_768: Breakpoint;
    bp_1024: Breakpoint;
    bp_1280: Breakpoint;
  };
}

interface IProps {
  style?: CSSProperties;
}

const LOGOS: LogoType[] = [
  {
    path: '/images/homepage-v2/vacation-logo.svg',
    name: 'Vacation',
    breakpoints: {
      bp_300: { width: 82, height: 24 },
      bp_640: { width: 110, height: 32 },
      bp_768: { width: 110, height: 32 },
      bp_1024: { width: 110, height: 32 },
      bp_1280: { width: 110, height: 32 },
    },
  },
  {
    path: '/images/homepage-v2/suckerz-logo.svg',
    name: 'Bad Mouth',
    breakpoints: {
      bp_300: { width: 59, height: 22 },
      bp_640: { width: 80, height: 30 },
      bp_768: { width: 80, height: 30 },
      bp_1024: { width: 80, height: 30 },
      bp_1280: { width: 80, height: 30 },
    },
  },
  {
    path: '/images/homepage-v2/arrae-logo.svg',
    name: 'Arrae',
    breakpoints: {
      bp_300: { width: 53, height: 16 },
      bp_640: { width: 80, height: 24 },
      bp_768: { width: 80, height: 24 },
      bp_1024: { width: 80, height: 24 },
      bp_1280: { width: 80, height: 24 },
    },
  },
  {
    path: '/images/homepage-v2/curie-logo.svg',
    name: 'Curie',
    breakpoints: {
      bp_300: { width: 73, height: 16 },
      bp_640: { width: 109, height: 24 },
      bp_768: { width: 109, height: 24 },
      bp_1024: { width: 109, height: 24 },
      bp_1280: { width: 109, height: 24 },
    },
  },
  {
    path: '/images/homepage-v2/forvr-mood-logo.svg',
    name: 'Forvr Mood',
    breakpoints: {
      bp_300: { width: 175, height: 18 },
      bp_640: { width: 175, height: 18 },
      bp_768: { width: 175, height: 18 },
      bp_1024: { width: 175, height: 18 },
      bp_1280: { width: 175, height: 18 },
    },
  },
];

const LOGOS2: LogoType[] = [
  {
    path: '/images/homepage-v2/dedcool-logo.png',
    name: 'Dedcool',
    breakpoints: {
      bp_300: { width: 95, height: 24 },
      bp_640: { width: 95, height: 24 },
      bp_768: { width: 95, height: 24 },
      bp_1024: { width: 95, height: 24 },
      bp_1280: { width: 95, height: 24 },
    },
  },
  {
    path: '/images/homepage-v2/finn-logo.png',
    name: 'Finn',
    breakpoints: {
      bp_300: { width: 83, height: 24 },
      bp_640: { width: 83, height: 24 },
      bp_768: { width: 83, height: 24 },
      bp_1024: { width: 83, height: 24 },
      bp_1280: { width: 83, height: 24 },
    },
  },
  {
    path: '/images/homepage-v2/mentality-logo.png',
    name: 'Mentality',
    breakpoints: {
      bp_300: { width: 48, height: 32 },
      bp_640: { width: 48, height: 32 },
      bp_768: { width: 48, height: 32 },
      bp_1024: { width: 48, height: 32 },
      bp_1280: { width: 48, height: 32 },
    },
  },
  {
    path: '/images/homepage-v2/homecourt-logo.png',
    name: 'Homecourt',
    breakpoints: {
      bp_300: { width: 181, height: 24 },
      bp_640: { width: 181, height: 24 },
      bp_768: { width: 181, height: 24 },
      bp_1024: { width: 181, height: 24 },
      bp_1280: { width: 181, height: 24 },
    },
  },
  {
    path: '/images/homepage-v2/skinny-logo.png',
    name: 'Skinny Confidential',
    breakpoints: {
      bp_300: { width: 176, height: 24 },
      bp_640: { width: 176, height: 24 },
      bp_768: { width: 176, height: 24 },
      bp_1024: { width: 176, height: 24 },
      bp_1280: { width: 176, height: 24 },
    },
  },
  {
    path: '/images/homepage-v2/clearstem-logo.png',
    name: 'Clearstem Skincare',
    breakpoints: {
      bp_300: { width: 141, height: 32 },
      bp_640: { width: 141, height: 32 },
      bp_768: { width: 141, height: 32 },
      bp_1024: { width: 141, height: 32 },
      bp_1280: { width: 141, height: 32 },
    },
  },
];

const BrandLogos = ({ style }: IProps) => {
  const { width } = useWindowSize();

  const [breakpointKey, setBreakpointKey] = useState<string>('bp_300');

  useEffect(() => {
    setBreakpointKey('bp_1280');

    if (width < 1280) {
      setBreakpointKey('bp_1024');
    }

    if (width < 1024) {
      setBreakpointKey('bp_768');
    }

    if (width < 768) {
      setBreakpointKey('bp_640');
    }

    if (width < 640) {
      setBreakpointKey('bp_300');
    }
  }, [width]);

  return (
    <div className="homepage-brand-logos" style={style}>
      <div className="content-max">
        <div className="logos">
          {map(LOGOS, (logo: LogoType) => {
            return (
              <Image
                key={logo.path}
                src={logo.path}
                alt={logo.name}
                width={logo.breakpoints[breakpointKey].width}
                height={logo.breakpoints[breakpointKey].height}
              />
            );
          })}
        </div>
        <div className="logos">
          {map(LOGOS2, (logo: LogoType) => {
            return (
              <Image
                key={logo.path}
                src={logo.path}
                alt={logo.name}
                width={logo.breakpoints[breakpointKey].width}
                height={logo.breakpoints[breakpointKey].height}
              />
            );
          })}
        </div>

        <p className="desc">300,000+ brands & entrepreneurs have chosen Pietra</p>
      </div>
    </div>
  );
};

export default BrandLogos;
